export function getFrontendOrigin() {
  const vercelEnv = process.env.NEXT_PUBLIC_VERCEL_ENV
  const vercelProdHost = process.env.NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL
  const vercelBranchHost = process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL
  const vercelHost = vercelEnv === "production" ? vercelProdHost : vercelBranchHost
  const vercelUrl = vercelHost && `https://${vercelHost}`

  const frontendOrigin = vercelUrl || process.env.NEXT_PUBLIC_FRONTEND_ORIGIN

  if (!frontendOrigin) {
    throw new Error("Please set NEXT_PUBLIC_FRONTEND_ORIGIN")
  }

  return frontendOrigin
}

export const routes = {
  // product pages
  home: "/",
  format_collection: (handle: string | null | undefined) => (handle ? (`/kollektionen/${handle}` as const) : "#"),
  categories: "/kategorien",
  format_category: (handle: string | null | undefined) => (handle ? (`/kategorien/${handle}` as const) : "#"),
  lines: "/serien",
  format_line: (handle: string | null | undefined) => (handle ? (`/serien/${handle}` as const) : "#"),
  allProducts: "/alle-boxen",
  format_product: (handle: string | null | undefined) => (handle ? (`/box/${handle}` as const) : "#"),
  search: "/suche",
  searchResults: "/ergebnisse",

  // checkout pages
  cart: "/warenkorb",
  checkout: "/kasse",
  paymentFailed: "/kasse/fehlgeschlagen",
  format_checkoutStep: (step: string) => `/kasse?step=${step}` as const,
  thankYouRoot: "/danke",
  format_thankYou: (cartOrOrderId: string) => `/danke/${cartOrOrderId}` as const,

  // special pages
  wishlist: "/wunschliste",

  // account pages
  accountRoot: "/account",
  accountAddresses: "/account/adressen",
  accountOrders: "/account/bestellungen",
  format_accountOrder: (orderId: string) => `/account/bestellungen/${orderId}` as const,
  accountProfile: "/account/profil",

  // about pages
  aboutUs: "/ueber-uns",
  career: "/karriere",

  // legal pages
  cookies: "/cookies",
  legalInfo: "/impressum",
  payment: "/zahlung",
  privacy: "/datenschutz",
  revocation: "/widerruf",
  shipping: "/versand",
  terms: "/agb",

  // support pages
  contact: "/kontakt",
  format_contactOption: (option: string) => `/kontakt?auswahl=${option}` as const,
  shipmentTracking: "/sendungsverfolgung",
  format_shipmentTracking: (shipmentId: string) => `/sendungsverfolgung?id=${shipmentId}` as const,

  // api
  enableDraftMode: "/api/draft-mode/enable",
  disableDraftMode: "/api/draft-mode/disable",
} as const
